module.exports = __webpack_public_path__ + "img/zzdp-title-icon-zrdp.2052052e.png";